'use strict';

function fileKind(name, mime) {
  const ext = String(name || '').slice(String(name || '').lastIndexOf('.')).toLowerCase();
  if (ext === '.pdf' || String(mime || '').includes('pdf')) return 'pdf';
  if (['.png', '.jpg', '.jpeg', '.gif', '.webp'].includes(ext) || String(mime || '').startsWith('image/')) {
    return 'image';
  }
  return 'other';
}

function docOpenMode({ name, mime, available } = {}) {
  if (available === false) return 'unavailable';
  const kind = fileKind(name, mime);
  if (kind === 'pdf' || kind === 'image') return 'preview';
  return 'download';
}

export { fileKind, docOpenMode };
